export const countries = ["Česká Republika", "Slovensko"];